function Event({ date, url, title }) {
    function getWeekdayInDutch(date) {
        const weekdaysInDutch = [
            "Zondag",
            "Maandag",
            "Dinsdag",
            "Woensdag",
            "Donderdag",
            "Vrijdag",
            "Zaterdag",
        ];
        const dateDateInstance = new Date(
            Number(date.split("-")[2]),
            Number(date.split("-")[1] - 1),
            Number(date.split("-")[0])
        );
        return weekdaysInDutch[dateDateInstance.getDay()];
    }
    function formatDate(date) {
        const calenderdate = date.slice().replaceAll("-", ".");
        const splitCalendarDate = calenderdate.split(".");
        const parsedDay = splitCalendarDate[0].padStart(2, "0");
        const parsedDate = [parsedDay, ...splitCalendarDate.slice(1)].join(".");
        return parsedDate;
    }
    const weekday = getWeekdayInDutch(date);
    const formattedDate = formatDate(date);
    function openInNewTab(url) {
        const newWindow = window.open(url, "_blank", "noopener,noreferrer");
        if (newWindow) newWindow.opener = null;
    }
    return (
        <li onClick={() => openInNewTab(url)} className="event">
            {weekday}
            <br></br>
            {formattedDate}
            <br></br>
            {title}
        </li>
    );
}

export default Event;
